import axios from 'axios'

// One in-flight request per dashboard section. A slower, superseded response
// must never replace the data for the filters the user selected most recently.
export function createDashboardRequests() {
  const pending = new Map()
  return {
    async post(section, url, payload, headers) {
      if (pending.has(section)) pending.get(section).cancel()
      const source = axios.CancelToken.source()
      pending.set(section, source)
      try {
        const response = await axios.post(url, payload, {
          headers, timeout: 30000, cancelToken: source.token
        })
        return pending.get(section) === source ? response : null
      } catch (error) {
        if (axios.isCancel(error) || pending.get(section) !== source) return null
        throw error
      } finally {
        if (pending.get(section) === source) pending.delete(section)
      }
    },
    cancelAll() {
      pending.forEach(source => source.cancel())
      pending.clear()
    }
  }
}
